import {SettingsEntry} from '../Directives/settings-dialog/settings-dialog';

export class SettingsDialog {
  open(callback: (option: SettingsEntry) => void) {

  }
}